import { type AuthUser } from '@/types';
import { defineStore } from 'pinia';

export const useCreditsStore = defineStore('credits', {
  state: () => ({
    creditsRemaining: 0,
    creditsMax: 0,
    maxMonthlyCreditsLimit: 0,
    user: null as AuthUser | null,
    creditsPurchased: 0
  }),
  actions: {
    async recalculateCredits() {
      try {
        const client = useSanctumClient();
        const { data } = await useAsyncData('me', () => client('/users/me'));
        if (data.value) {
          this.$state.user = data.value;
        }

        const max_limit = this.$state.user?.vendor?.capabilities?.find(
          (cap) => cap.name === 'ai_scanner_monthly'
        )?.max_limit;

        this.$state.maxMonthlyCreditsLimit =
          max_limit && max_limit > 0 ? max_limit : 0;

        const aiScannerCapability =
          this.$state.user?.vendor?.capabilities?.find(
            (cap) => cap.name === 'ai_scanner_monthly'
          );

        const aiScannerCapabilityPurchase =
          this.$state.user?.vendor?.capabilities?.find(
            (cap) => cap.name === 'ai_scanner_credit_purchase'
          );

        if (aiScannerCapability) {
          const monthlyCount = Math.max(
            0,
            aiScannerCapability.max_limit - aiScannerCapability.current_usage
          );
          const countPurchase = Math.max(
            0,
            (aiScannerCapabilityPurchase?.max_limit ?? 0) -
              (aiScannerCapabilityPurchase?.current_usage ?? 0)
          );
          this.$state.creditsRemaining = Math.max(
            0,
            monthlyCount + countPurchase
          );
          this.$state.creditsMax = aiScannerCapability.max_limit;
          this.$state.creditsPurchased = countPurchase;
        } else {
          this.$state.creditsRemaining = 0;
          this.$state.creditsMax = 0;
        }
      } catch (error) {
        console.error('Failed to fetch credits:', error);
      }
    }
  }
});
